import { render, staticRenderFns } from "./AppHeader.vue?vue&type=template&id=455ecd56&scoped=true&lang=pug&"
import script from "./AppHeader.vue?vue&type=script&lang=js&"
export * from "./AppHeader.vue?vue&type=script&lang=js&"
import style0 from "./AppHeader.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AppHeader.vue?vue&type=style&index=1&id=455ecd56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455ecd56",
  null
  
)

export default component.exports